import React from 'react';
import { BRAND } from '../data/site';
export function SiteFooter() {
  return <footer className="w-full bg-sage-800 px-5 py-14 text-center sm:px-8" data-id="element-189" data-mp="3r89cl6b6ipfd">
      <p className="font-serif text-2xl text-cream" data-id="element-190" data-mp="3racd4k9yk0yc">{BRAND.name}</p>
      <p className="mt-3 text-[12px] uppercase tracking-[0.18em] text-sage-200" data-id="element-191" data-mp="3mg86610ozsx9">
        Manualidades botánicas · Guías digitales
      </p>
      <p className="mt-6 text-[11.5px] text-sage-300" data-id="element-192" data-mp="3hglrro94o6mv">
        © {new Date().getFullYear()} {BRAND.name}. Todos los derechos reservados.
      </p>
    </footer>;
}